"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Profile = _interopRequireDefault(require("../CRM/Clients/Profile"));
var _RoundCountdown = _interopRequireDefault(require("../CRM/Calls/RoundCountdown"));
var _Select = _interopRequireDefault(require("../Select"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledSelectedOption = _Select["default"].StyledSelected,
  StyledOptions = _Select["default"].StyledOptions,
  StyledOptionWrapper = _Select["default"].StyledOption,
  StyledStatusIcon = _Select["default"].StyledStatusIcon;
var ProfilePropTypes = _Profile["default"].propTypes;
var OperatorStates = {
  AFTER_SERVICE: 'afterService',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  OFFLINE: 'offline',
  ONLINE: 'online',
  READY: 'ready'
};
var defaultStates = [OperatorStates.READY, OperatorStates.OFFLINE];
var voxStates = [OperatorStates.READY, OperatorStates.ONLINE, OperatorStates.DND, OperatorStates.OFFLINE];
var defaultLabels = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, OperatorStates.READY, 'Доступен'), OperatorStates.OFFLINE, 'Недоступен');
var voxStatusLabels = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, OperatorStates.AFTER_SERVICE, 'Завершение звонка'), OperatorStates.DND, 'Недоступен для звонка/перевода'), OperatorStates.IN_SERVICE, 'В разговоре'), OperatorStates.OFFLINE, 'Вне смены'), OperatorStates.ONLINE, 'Доступен для перевода (II очередь)'), OperatorStates.READY, 'Доступен для звонка/перевода');
var OperatorStatusSelector = /*#__PURE__*/function (_React$PureComponent) {
  function OperatorStatusSelector(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, OperatorStatusSelector);
    _this = _callSuper(this, OperatorStatusSelector, [props]);
    _this.state = {
      value: props.value,
      manualState: props.value
    };
    _this.handleAfterService = _this.handleAfterService.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.headRenderer = _this.headRenderer.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(OperatorStatusSelector, _React$PureComponent);
  return (0, _createClass2["default"])(OperatorStatusSelector, [{
    key: "handleAfterService",
    value: function handleAfterService() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        manualState = _this$props.manualState;
      this.setState(function (prevState) {
        return {
          manualState: null,
          value: prevState.manualState
        };
      }, function () {
        onChange({
          isManual: true,
          manualState: null,
          state: manualState,
          operatorState: manualState
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref) {
      var detail = _ref.detail;
      var onChange = this.props.onChange;
      var value = detail.value;
      var newData = {
        value: value,
        isManual: true
      };
      this.setState(newData, function () {
        return onChange({
          isManual: true,
          state: value,
          operatorState: value
        });
      });
    }
  }, {
    key: "headRenderer",
    value: function headRenderer() {
      var _this$props2 = this.props,
        person = _this$props2.person,
        value = _this$props2.value;
      var isAfterService = value === OperatorStates.AFTER_SERVICE;
      return /*#__PURE__*/_react["default"].createElement(StyledHead, null, /*#__PURE__*/_react["default"].createElement(StyledProfile, {
        person: person
      }), !isAfterService ? /*#__PURE__*/_react["default"].createElement(StyledStatusIndicator, {
        status: value
      }) : /*#__PURE__*/_react["default"].createElement(StyledRoundCountdown, {
        seconds: 25,
        onStop: this.handleAfterService
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        person = _this$props3.person,
        value = _this$props3.value;
      var options = OperatorStatusSelector.generatedOptions(person.isOperator);
      return /*#__PURE__*/_react["default"].createElement(StyledOperatorStatusSelector, (0, _extends2["default"])({}, this.props, {
        key: value,
        headRenderer: this.headRenderer,
        optionRenderer: OperatorStatusSelector.optionRenderer,
        options: options,
        value: value,
        optionHeight: 46,
        onChange: this.handleChange
      }));
    }
  }], [{
    key: "generatedOptions",
    value: function generatedOptions(isVoxOperator) {
      var labels = isVoxOperator ? voxStatusLabels : defaultLabels;
      var options = isVoxOperator ? voxStates : defaultStates;
      return options.map(function (value) {
        return {
          title: labels[value],
          value: value
        };
      });
    }
  }, {
    key: "optionRenderer",
    value: function optionRenderer(_ref2) {
      var title = _ref2.title,
        value = _ref2.value;
      return /*#__PURE__*/_react["default"].createElement(StyledOption, null, /*#__PURE__*/_react["default"].createElement(StyledOptionIndicator, {
        status: value
      }), title);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var nextForceVal = props.value;
      var nextVal = state.value,
        manualState = state.manualState;
      var isStateChanged = manualState !== nextVal;
      var isPropChanged = manualState !== nextForceVal;
      if (isStateChanged) {
        return {
          value: nextVal,
          manualState: nextVal
        };
      }
      if (isPropChanged) {
        return {
          manualState: nextForceVal,
          value: nextForceVal
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
OperatorStatusSelector.propTypes = _objectSpread(_objectSpread({}, ProfilePropTypes), {}, {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  manualState: _propTypes["default"].oneOf(Object.values(OperatorStates)).isRequired,
  value: _propTypes["default"].oneOf(Object.values(OperatorStates)).isRequired
});
OperatorStatusSelector.defaultProps = {
  className: '',
  disabled: false,
  onChange: Function.prototype
};
var StyledOperatorStatusSelector = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "OperatorStatusSelector__StyledOperatorStatusSelector",
  componentId: "sc-16upzor-0"
})(["width:auto;font-size:12px;position:relative;line-height:normal;", "{padding:0;opacity:1;}", "{right:0;overflow:visible;margin-top:10px;position:absolute;margin-right:20px;&:before{left:auto;right:15px;}}", "{color:black;min-height:39px;line-height:39px;background-color:transparent;&[data-selected='true']{background-color:#dcedff;}}", "{display:none;}", ""], StyledSelectedOption, StyledOptions, StyledOptionWrapper, StyledStatusIcon, function (p) {
  return (p.value === OperatorStates.READY || p.value === OperatorStates.IN_SERVICE) && "\n    ".concat(StyledOptions, ":before {\n      border-bottom-color: #dcedff;\n    }\n  ");
});
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "OperatorStatusSelector__StyledHead",
  componentId: "sc-16upzor-1"
})(["color:white;display:flex;"]);
var StyledProfile = (0, _styledComponents["default"])(_Profile["default"]).withConfig({
  displayName: "OperatorStatusSelector__StyledProfile",
  componentId: "sc-16upzor-2"
})(["text-align:left;"]);
var StyledOption = _styledComponents["default"].div.withConfig({
  displayName: "OperatorStatusSelector__StyledOption",
  componentId: "sc-16upzor-3"
})(["display:flex;white-space:nowrap;padding-right:30px;font-size:14px;align-items:center;"]);
var StyledIndicator = _styledComponents["default"].div.withConfig({
  displayName: "OperatorStatusSelector__StyledIndicator",
  componentId: "sc-16upzor-4"
})(["width:10px;height:10px;border-radius:50%;", " ", " ", " ", ""], function (p) {
  return p.status === OperatorStates.DND && "\n    background-image: linear-gradient(to top, #e5200e, #ff860c);\n  ";
}, function (p) {
  return (p.status === OperatorStates.OFFLINE || p.status === OperatorStates.AFTER_SERVICE) && "\n    background-color: #c2c5cc;\n  ";
}, function (p) {
  return p.status === OperatorStates.ONLINE && "\n    background-image: linear-gradient(to top, #f7aa1b, #faed61);\n  ";
}, function (p) {
  return (p.status === OperatorStates.READY || p.status === OperatorStates.IN_SERVICE) && "\n    background-image: linear-gradient(to top, #00b0b6, #00e04b);\n  ";
});
var StyledStatusIndicator = (0, _styledComponents["default"])(StyledIndicator).withConfig({
  displayName: "OperatorStatusSelector__StyledStatusIndicator",
  componentId: "sc-16upzor-5"
})(["margin-top:8px;margin-left:8px;margin-right:8px;"]);
var StyledOptionIndicator = (0, _styledComponents["default"])(StyledIndicator).withConfig({
  displayName: "OperatorStatusSelector__StyledOptionIndicator",
  componentId: "sc-16upzor-6"
})(["margin-right:10px;"]);
var StyledRoundCountdown = (0, _styledComponents["default"])(_RoundCountdown["default"]).withConfig({
  displayName: "OperatorStatusSelector__StyledRoundCountdown",
  componentId: "sc-16upzor-7"
})(["margin-left:2px;margin-top:1px;"]);
OperatorStatusSelector.OperatorStates = OperatorStates;
var _default = exports["default"] = OperatorStatusSelector;